import { render, staticRenderFns } from "./map.vue?vue&type=template&id=01e477eb&"
import script from "./map.vue?vue&type=script&lang=js&"
export * from "./map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01e477eb')) {
      api.createRecord('01e477eb', component.options)
    } else {
      api.reload('01e477eb', component.options)
    }
    module.hot.accept("./map.vue?vue&type=template&id=01e477eb&", function () {
      api.rerender('01e477eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/orders/tabs/map.vue"
export default component.exports